<template>
    <el-container id="container">
        <el-header id="header">
            <el-row :gutter="10">
                <el-col :xl="12" :lg="8" :md="8" :sm="12" :xs="12" class="hidden-md-and-down">
                    <router-link to="/" class="app-title">{{appName}}</router-link>
                </el-col>
                <el-col :xl="12" :lg="6" :md="4" :sm="4" :xs="4" class="hidden-lg-and-up">
                    <router-link to="/" class="app-title" style="font-size: 0.8rem">
                        <strong style="font-size: 1.3rem">PE</strong>
                    </router-link>
                </el-col>
                <el-col :xl="12" :lg="16" :md="20" :sm="20" :xs="20" class="hidden-xs-only">
                    <div style="display: flex;margin-right: 0; width: 100%;">
                        <el-menu
                                mode="horizontal"
                                background-color="#1867c0"
                                text-color="#fff"
                                active-text-color="#ffff00"
                                :default-active="selectedMenuKey"

                        >
                            <template v-for="def of menuDefs">
                                <template v-if="def.children.length === 0">
                                    <el-menu-item :key="def.name" :index="def.name" @click="menuClick(def)">
                                        {{def.title}}
                                    </el-menu-item>
                                </template>
                                <template v-else>
                                    <el-submenu :key="def.name" :index="def.name" popper-class="submenu">
                                        <template #title>
                                            {{def.title}}
                                        </template>
                                        <el-menu-item
                                                v-for="sub in def.children"
                                                :key="sub.name"
                                                :index="sub.name"
                                                @click="menuClick(sub)"
                                        >
                                            {{sub.title}}
                                        </el-menu-item>
                                    </el-submenu>
                                </template>
                            </template>
                        </el-menu>
                        <el-popover
                                ref="popover"
                                placement="top-start"
                                :title="name"
                                width="200"
                                trigger="click"
                        >
                            <el-button @click="logout">登出</el-button>
                        </el-popover>
                        <span
                                v-popover:popover
                                class="user">
                            {{name}}
                         </span>
                    </div>
                </el-col>
                <el-col class="hidden-sm-and-up" :xs="20">
                    <div id="folder">
                        <el-button
                                :icon="showCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
                                type="primary"
                                size="medium"
                                @click="showCollapse=!showCollapse"
                        ></el-button>
                    </div>
                </el-col>
            </el-row>

        </el-header>
        <el-main id="main">
            <div
                    v-if="showCollapse"
                    class="animated"
            >
                <el-menu
                        background-color="#020e21"
                        text-color="#fff"
                        active-text-color="#ffff00"
                        :default-active="selectedMenuKey"

                >
                    <template v-for="def of menuDefs">
                        <template v-if="def.children.length === 0">
                            <el-menu-item :key="def.name" :index="def.name" @click="menuClick(def)">
                                {{def.title}}
                            </el-menu-item>
                        </template>
                        <template v-else>
                            <el-submenu :key="def.name" :index="def.name" popper-class="submenu">
                                <template #title>
                                    {{def.title}}
                                </template>
                                <el-menu-item
                                        v-for="sub in def.children"
                                        :key="sub.name"
                                        :index="sub.name"
                                        @click="menuClick(sub)"
                                >
                                    {{sub.title}}
                                </el-menu-item>
                            </el-submenu>
                        </template>
                    </template>
                    <el-menu-item
                            @click="logout"
                    >
                        登出
                    </el-menu-item>
                </el-menu>
            </div>
            <slot></slot>
            <el-backtop target="#main" ref="backtop"></el-backtop>
        </el-main>
        <el-footer id="footer" class="hidden-md-and-down">
            &copy;{{`${new Date().getFullYear()}`}}
            <span style="padding-left: 2px;"><a href="http://www.ncut.edu.tw" target="_blank">國立勤益科技大學</a></span>
        </el-footer>
    </el-container>
</template>

<script>
    import {mapGetters, mapMutations, mapState} from 'vuex';
    import appNameMixin from '../appNameMixin';

    export default {
        name: 'MainLayout',
        data: () => ({
            selectedMenuKey: '',
            showCollapse: false
        }),
        mixins:[appNameMixin],
        computed: {
            ...mapState(['loading']),
            ...mapState({
                name: state => state.auth.name
            }),
            ...mapGetters(['menuDefs']),
            minHeight() {
                return `${60 * this.menuDefs.length}px`;
            }
        },
        methods: {
            ...mapMutations({
                logout: 'auth/logout',
            }),
            menuClick(def) {
                this.$router.push(def);
                this.showCollapse = false;

            }
        },
        watch: {
            $route(to) {
                this.selectedMenuKey = to.name;
            },
            showCollapse(current){
                if(current){
                    this.$refs.backtop.scrollToTop();
                }
            }
        },

        async created() {
            this.selectedMenuKey = this.$route.name;
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,500,700,900&subset=chinese-traditional');

    #container {
        min-height: 100%;
        height: 100%;
        background-color: #f0f2f5;
    }

    #container #header {
        background: #1867c0;
        padding-right: 15px;
        min-height: 60px;
    }

    #container #header .el-menu,
    #container #header .el-submenu {
        height: 60px;
        line-height: 60px;
        border-bottom: none;
        margin-left: auto;
    }

    #container #header .el-menu-item,
    #container #header .el-submenu__title {
        font-size: 1.1rem;
    }

    .submenu .el-menu-item {
        font-size: 1.0rem;
    }

    #container #header .user {
        padding-left: 10px;
        background: #1867c0;
        height: 60px;
        line-height: 60px;
        color: white;
        font-size: 1.1rem;
        cursor: pointer;
    }

    #container #header #user > .name {
        padding-left: 10px;

    }

    #container #header .app-title {
        font-family: 'Noto Sans TC', sans-serif !important;
        line-height: 60px;
        font-size: 24px;
        color: white;
        text-decoration: none;
    }

    #container #main {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }

    #container .el-breadcrumb {
        height: 30px;
        line-height: 30px;
    }

    #container #footer {
        font-family: 'Noto Sans TC', sans-serif !important;
        text-align: center;
        background: #1867c0;
        color: #ffffff;
    }

    #container #footer a {
        text-decoration: none;
        font-size: 14px;
        line-height: 60px;
        color: #ffffff;
        flex: 0 !important;
    }

    #container #folder {
        display: flex;
        margin-right: 0;
        width: 100%;
        justify-content: flex-end;
        height: 60px;
        align-items: center;
    }

    #container .el-collapse{
        border: none;
    }

    #container .el-collapse-item__header {
        background-color: #1867c0;
        border: none;
        height: 60px;
        line-height: 60px;
        color: white;
        font-size: 1.1rem;
    }

    #container .menu-bar
    {
        height: 60px;
        line-height: 60px;
        color: white;
        font-size: 1.1rem;
        padding-left: 20px;
    }

    #container .menu-bar.active{
        background-color: #186710;
    }
</style>
